import { Track } from "@/src/lib/tracking";
import React, { useEffect, useRef, useState } from "react";

interface IframeProps {
  src: string;
  className?: string;
}

export const Iframe: React.FC<IframeProps> = ({ src, className }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeHeight, setIframeHeight] = useState("100vh");
  const ipfsGateway =
    process.env.NEXT_PUBLIC_IPFS_GATEWAY || "https://test.trexprotocol.com";
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // 验证消息来源
      if (!event.origin.includes(ipfsGateway)) {
        return;
      }

      try {
        // 检查消息数据是否为字符串
        const data =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        // 处理高度调整消息
        if (data.type === "resize" && typeof data.height === "number") {
          setIframeHeight(`${data.height}px`);
        }
      } catch (error) {
        Track.log("error", "Iframe", "处理 iframe 消息时出错:", {
          cause: String(error),
        });
      }
    };

    // 添加消息监听器
    window.addEventListener("message", handleMessage);

    // 清理函数
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div className={`relative w-full pt-6 ${className || ""}`}>
      <iframe
        ref={iframeRef}
        src={src}
        className="w-full border-0 no-scrollbar"
        style={{
          height: iframeHeight,
        }}
        title="市场分析报告"
      />
    </div>
  );
};
